var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-text-field',{attrs:{"rules":_vm.rules,"label":_vm.registrationAnswer.label,"value":_vm.registrationAnswer.value,"outlined":"","required":"","dense":"","hide-details":"auto"},on:{"input":function($event){return _vm.onInput($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }